import { Grid, Paper, Typography } from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";

import Header from "../../../partials/header";
import moment from "moment";
import Snackbar from "../../snackbar";
import Loading from "../../loading";
import TypoTitle from "../../../partials/typoTitle";
import PickerDateRange from "../../../partials/pickerDateRange";
import TableFormat from "../../../partials/TableFormat";
import { styles } from "./styles";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import { formatDate } from "../../../utils/setting";

const headCellsOrderItem = [
  {
    key: "itemName",
    numeric: false,
    disablePadding: false,
    label: "customer_customer_report_items",
  },
  {
    key: "count",
    numeric: false,
    disablePadding: false,
    label: "customer_customer_report_orders_to_date",
  },
];
const headCellsOrderBranch = [
  {
    key: "branchName",
    numeric: false,
    disablePadding: false,
    label: "customer_customer_report_branches",
  },
  {
    key: "orderToDate",
    numeric: false,
    disablePadding: false,
    label: "customer_customer_report_orders_to_date",
  },
  {
    key: "orderValueToDate",
    numeric: false,
    disablePadding: false,
    label: "customer_customer_report_order_value_to_date",
  },
];
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

let to = moment().endOf("month");
let from = moment().subtract(1, "months").startOf("month");
class CustomerReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 1,
      data: {
        startedDate: 0,
        endedDate: 0,
        orderToDate: 0,
        orderToDateByDate: 0,
        averageOrderValue: 0,
        orderValueToDate: 0,
        orderValueToDateByDate: 0,
        itemList: [],
        branchList: [],
      },
      lastDate: to,
      firstDate: from,
      customerInfo: {},
    };
  }
  async componentDidMount() {
    const { match } = this.props;
    const { lastDate, firstDate } = this.state;
    let result = await this.props.getCustomerInfoById({
      id: match && match.params && match.params.id,
    });
    if (result.code === 1) {
      let customerInfo = result.data;
      this.setState({ customerInfo: customerInfo });
      this.props.reportOrderCustomer({
        customerMobile: customerInfo.customerMobile,
        countryCode: customerInfo.countryCode,
        firstDate: moment(firstDate).startOf("day").valueOf(),
        lastDate: moment(lastDate).endOf("day").valueOf(),
      });
      this.changeDateByDate();
    }
  }
  async changeDateByDate() {
    let { t } = this.props;
    const { customerInfo = {} } = this.state;
    const { lastDate, firstDate } = this.state;
    this.loading.startLoading();
    let check = await this.props.getDetailCustomerByDate({
      customerMobile: customerInfo.customerMobile,
      countryCode: customerInfo.countryCode,
      firstDate: moment(firstDate).startOf("day").valueOf(),
      lastDate: moment(lastDate).endOf("day").valueOf(),
    });
    this.loading.stopLoading();
    if (check.code === 1) {
      let { data = {} } = this.state;
      let detailCustomer = this.props.detailOrderCustomer || {};
      let itemsList = [],
        branchList = [];
      if (detailCustomer.order && detailCustomer.order.length) {
        for (let i = 0; i < detailCustomer.order.length; i++) {
          let checkExist = this.isInBranchList(
            detailCustomer.order[i],
            branchList
          );
          if (checkExist != -1) {
            branchList[checkExist].orderToDate =
              branchList[checkExist].orderToDate + 1;
            branchList[checkExist].orderValueToDate =
              branchList[checkExist].orderValueToDate +
              detailCustomer.order[i].totalPrice;
          } else {
            branchList.push({
              branchCode: detailCustomer.order[i].branchCode
                ? detailCustomer.order[i].branchCode
                : "-1",
              branchName: detailCustomer.order[i].branchName
                ? detailCustomer.order[i].branchName
                : "",
              orderToDate: 1,
              orderValueToDate: detailCustomer.order[i].totalPrice,
            });
          }
          for (let j = 0; j < detailCustomer.order[i].item.length; j++) {
            let item = detailCustomer.order[i].item[j];
            let checkExist = this.isInItemsList(item, itemsList);
            if (checkExist != -1) {
              itemsList[checkExist].count = itemsList[checkExist].count + 1;
            } else {
              itemsList.push({
                code:
                  item.itemType === "serviceItem" ? item.itemCode : item.code,
                itemName:
                  item.itemType === "serviceItem" ? item.itemName : item.title,
                count: 1,
              });
            }
          }
        }
        itemsList = itemsList.sort((a, b) =>
          a[itemsList.count] > b[itemsList.count] ? 1 : -1
        );
        branchList = branchList.sort((a, b) =>
          a[branchList.orderToDate] > b[branchList.orderToDate] ? -1 : 1
        );
      }
      data.itemList = itemsList;
      data.branchList = branchList;
      this.setState({ data: data });
    }
  }
  isInItemsList(item, itemsList) {
    let code = item.itemType === "serviceItem" ? item.itemCode : item.code;
    for (let i = 0; i < itemsList.length; i++) {
      if (itemsList[i].code === code) return i;
    }
    return -1;
  }
  isInBranchList(order, branchList) {
    let branchCode = order.branchCode ? order.branchCode : "-1";
    for (let i = 0; i < branchList.length; i++) {
      if (branchList[i].branchCode === branchCode) return i;
    }
    return -1;
  }
  handleFilterDate = (from, to) => {
    let _this = this;
    this.setState({ firstDate: from, lastDate: to }, function () {
      _this.changeDateByDate();
    });
  };
  render() {
    const { classes, t, startReportOrderCustomer, currencyCode } = this.props;
    const { customerInfo = {} } = this.state;
    const imgVoucherURL = customerInfo.customerImage || "/images/noneImage.svg";
    let averageOrderValue =
      startReportOrderCustomer.sumTotalPrice /
        startReportOrderCustomer.sumOrders || 0;
    return (
      <div>
        <Loading onRef={(id) => (this.loading = id)} />
        <Header
          session={t("customer_list_customers")}
          title={t("customer_report")}
          backIcon={true}
          actionBack={() => this.props.history.push("/customer")}
          colorButton={"default"}
        />
        <Paper classes={{ root: classes.rootPaper }}>
          <Snackbar
            color="white"
            onRef={(snackbar) => (this.mSnackbar = snackbar)}
          />
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={5}
              className={classes.containerOne}
            >
              <Grid container className={classes.container}>
                <div
                  className={classes.containerImage}
                  style={{ backgroundImage: "url(" + imgVoucherURL + ")" }}
                ></div>
                <div className={classes.content}>
                  <Typography variant="h6" className={classes.name}>
                    {customerInfo.customerName}
                  </Typography>
                  <Typography variant="body1" className={classes.code}>
                    {
                      _parsePhoneNumber(
                        customerInfo.countryCode,
                        customerInfo.customerMobile
                      ).format_internal
                    }
                  </Typography>
                  <Typography
                    variant="body1"
                    className={classes.firstDayBottom}
                  >
                    {t("customer_customer_report_first_order_day")}:
                    <span className={classes.date}>
                      {startReportOrderCustomer.firstDate
                        ? formatDate(startReportOrderCustomer.firstDate)
                        : "00/00/00"}
                    </span>
                  </Typography>
                  <Typography variant="body1">
                    {t("customer_customer_report_last_order_day")}:
                    <span className={classes.date}>
                      {startReportOrderCustomer.lastDate
                        ? formatDate(startReportOrderCustomer.lastDate)
                        : "00/00/00"}
                    </span>
                  </Typography>
                </div>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={7}>
              <Grid container className={classes.containerOrder}>
                <Grid item xs={12} sm={3} md={3} lg={3}>
                  <fieldset
                    className={classNames(
                      classes.containerOrder,
                      classes.borderNoneRight
                    )}
                  >
                    <legend className={classes.textCenter}>
                      {t("customer_customer_report_orders_to_date")}
                    </legend>
                    <div className={classes.containerOrderContent}>
                      <Typography
                        variant="h5"
                        className={classes.averageValueOrder}
                      >
                        {startReportOrderCustomer.sumOrders}
                      </Typography>
                    </div>
                  </fieldset>
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4}>
                  <fieldset
                    className={classNames(
                      classes.containerOrder,
                      classes.border
                    )}
                  >
                    <legend className={classes.textCenter}>
                      {t("customer_customer_report_average order value")}
                    </legend>
                    <div className={classes.containerOrderContent}>
                      <Typography
                        variant="h5"
                        className={classes.averageValueOrder}
                      >
                        {averageOrderValue.toLocaleString("it-IT")}
                      </Typography>
                      <Typography
                        variant="h5"
                        className={classes.currencyOrder}
                      >
                        {currencyCode}
                      </Typography>
                    </div>
                  </fieldset>
                </Grid>
                <Grid item xs={12} sm={5} md={5} lg={5}>
                  <fieldset
                    className={classNames(
                      classes.containerOrder,
                      classes.borderNoneLeft
                    )}
                  >
                    <legend className={classes.textCenter}>
                      {t("customer_customer_report_order_value_to_date")}
                    </legend>
                    <div className={classNames(classes.containerOrderContent)}>
                      <Typography
                        variant="h5"
                        className={classes.orderValueOrder}
                      >
                        {startReportOrderCustomer.sumTotalPrice
                          ? startReportOrderCustomer.sumTotalPrice.toLocaleString(
                              "it-IT"
                            )
                          : 0}
                      </Typography>
                      <Typography
                        variant="h5"
                        className={classes.currencyOrder}
                      >
                        {currencyCode}
                      </Typography>
                    </div>
                  </fieldset>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        <Grid container>
          <form className={classes.form}>
            <PickerDateRange
              from={this.state.firstDate}
              to={this.state.lastDate}
              showButtonFilter={true}
              alignItems="left"
              handleFilterDate={this.handleFilterDate}
              // titleToolip={t("Filter by")}
            />
          </form>
        </Grid>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={12} md={5} lg={5}>
            {/* <div className={classes.titleOrders}><TypoTitle gutterBottom >{t('customer_customer_report_orders_by_items')}</TypoTitle> </div> */}
            <TableFormat
              onRef={(ref) => (this.mTable = ref)}
              orderBy=""
              title={t("customer_customer_report_orders_by_items")}
              hiddenInfoRcord={true}
              showFilter={false}
              hiddenPagination={true}
              headCells={headCellsOrderItem}
              size={"medium"}
              isCollapse={false}
              hiddenSearch={true}
              showCheckBox={false}
              showFilterBranch={false}
              getList={() => {}}
              rows={this.state.data.itemList.map((row, index) => {
                return {
                  id: row._id,
                  itemName: row.itemName,
                  count: row.count,
                };
              })}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={7} lg={7}>
            {/* <div className={classes.titleOrders}><TypoTitle gutterBottom >{t('customer_customer_report_orders_by_branches')}</TypoTitle> </div> */}
            <TableFormat
              onRef={(ref) => (this.mTable = ref)}
              orderBy=""
              hiddenInfoRcord={true}
              title={t("customer_customer_report_orders_by_branches")}
              showFilter={false}
              hiddenPagination={true}
              headCells={headCellsOrderBranch}
              size={"medium"}
              isCollapse={false}
              hiddenSearch={true}
              showCheckBox={false}
              showFilterBranch={false}
              getList={() => {}}
              rows={this.state.data.branchList.map((row, index) => {
                return {
                  id: row._id,
                  branchName: row.branchName,
                  orderToDate: row.orderToDate,
                  orderValueToDate: `${row.orderValueToDate.toLocaleString(
                    "it-IT"
                  )} ${currencyCode}`,
                };
              })}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

CustomerReport.propTypes = {
  classes: PropTypes.object.isRequired,
};

CustomerReport.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  customerInfo: state.customer.customerInfo,
  detailOrderCustomer: state.customer.detailOrderCustomer,
  startReportOrderCustomer: state.order.reportOrderCustomer,
  currencyCode: state.setting.setting.currencyCode,
});

const mapDispatch = (dispatch) => ({
  getDetailCustomerByDate: dispatch.customer.getDetailCustomerByDate,
  reportOrderCustomer: dispatch.order.reportOrderCustomer,
  getCustomerInfoById: dispatch.customer.getCustomerInfoById,
});

CustomerReport.propTypes = {};

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(CustomerReport)
  )
);
